export default __webpack_public_path__ + "static/media/IMG_3010.92d4c2c5.JPG";